
import {
  getMerchantStates, getMerchantCountries, deleteMerchantCountry, updateMerchantCountry, getMerchantCities,
} from '../../services/location';

export default {
  /**
   * Get All countries
   * @param commit
   * @param page
   * @param limit
   * @returns {Promise<void>}
   */
  async fetchMerchantCountries({ commit }, { page, limit }) {
    const response = await getMerchantCountries(page, limit);
    commit('setProperty', { property: 'countries', payload: response });
  },

  /**
   *
   * @param commit
   * @param countryId
   * @returns {Promise<void>}
   */
  async deleteMerchantCountry({ dispatch }, { countryId }) {
    await deleteMerchantCountry(countryId);
    dispatch('fetchMerchantCountries', { page: 1, limit: 20 });
  },

  /**
   *
   * @param context
   * @param countryId
   * @param country
   * @returns {Promise<void>}
   */
  async updateMerchantCountry(context, { countryId, country }) {
    await updateMerchantCountry(countryId, country);
  },

  /**
   *
   * @param commit
   * @param countryId
   * @returns {Promise<void>}
   */
  async fetchMerchantStates({ commit }, { countryId }) {
    const response = await getMerchantStates(countryId);
    commit('setProperty', { property: 'states', payload: response });
    commit('setProperty', { property: 'cities', payload: response[0].cities });
  },

  /**
   *
   * @param commit
   * @param stateId
   * @returns {Promise<void>}
   */
  async fetchMerchantCities({ commit }, { stateId }) {
    const response = await getMerchantCities(stateId);
    commit('setProperty', { property: 'cities', payload: response[0].cities });
  },
};
